import { ref, computed } from "vue";
import { defineStore } from "pinia";

import {
  setUserSession,
  clearUserSession,
  getUserData,
} from "@/stores/localStorage.js";

export const useProfileStore = defineStore("profile-store", () => {
  const profileSellerCodes = ref([]);

  const userData = ref({});

  const pageMeta = ref({
    current_page: 1,
    first_page_url: "",
    from: 1,
    last_page: 1,
    last_page_url: "",
    links: [],
  });

  // * Methods ======================================================

  const setPageMeta = (newMeta) => (pageMeta.value = { ...newMeta });
  const setCurrentPage = (newPage) => (pageMeta.value.current_page = newPage);
  const setPrev = () => {
    if (pageMeta.value.current_page > 1) --pageMeta.value.current_page;
  };
  const setNext = () => {
    if (pageMeta.value.current_page < pageMeta.value.last_page)
      ++pageMeta.value.current_page;
  };

  const setUserData = (data) => {
    setUserSession(data);
    userData.value = { ...getUserData() };
  };

  return {
    userData,

    profileSellerCodes,
    pageMeta,

    setUserData,
    setPageMeta,
    setCurrentPage,
    setPrev,
    setNext,
  };
});

export default useProfileStore;
